module.exports = __webpack_public_path__ + "img/128x128_circle_carrier.2025af9f.svg";